import React from "react";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

const EUCommunicationRecordAnalyticsComponent = () => {
  return (
    <main className="middle_section dashboard_middle">
      <div className="container">
        <NotSubscribedMessageComponent />
      </div>
    </main>
  );
};

export default EUCommunicationRecordAnalyticsComponent;

